module.exports = __webpack_public_path__ + "static/img/photo.130ce878.png";